import React, { type ReactNode } from 'react';
import { SpotlightTarget as SpotlightTargetOriginal } from '@atlaskit/onboarding';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { withNestingOptimisation } from '../with-nesting-optimisation/index.tsx';

// Copied from @atlaskit/onboarding since it isn't exported
type TargetRef = (element: HTMLElement | null | undefined) => void;
type RenderChildrenFunction = (props: { targetRef?: TargetRef }) => ReactNode;

export interface SpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode | RenderChildrenFunction;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
}

const SpotlightTargetWrapper = ({ children, ...props }: SpotlightTargetProps) => (
	<SpotlightTargetOriginal {...props}>
		{/*
		 * The atlaskit spotlight target component merely registers a ref on the child component,
		 *  so there is no way to give it a test id. We want to keep the test id as closely coupled
		 *  with the target as possible, so we add a span with id here, rather than on the child
		 *  where it could become more easily uncoupled.
		 */}
		{/* @ts-expect-error - TS2322 - Type '{ children: ReactNode | RenderChildrenFunction; }' is not assignable to type '{ children?: ReactNode; }'. */}
		<span data-test-id={`ak-spotlight-target-${props.name}`}>{children}</span>
	</SpotlightTargetOriginal>
);

const SpotlightTargetOld = withNestingOptimisation<SpotlightTargetProps>(SpotlightTargetWrapper);

export const SpotlightTarget = componentWithCondition(
	() => fg('jfp-magma-4013-fix-top-nav-ssr-hydration'),
	SpotlightTargetWrapper,
	SpotlightTargetOld,
);
